export default "<ion-content *ngIf=\"qrcode && product\">\n  <ion-router-outlet animated=\"false\"></ion-router-outlet>\n</ion-content>\n";